import "./Solutions.module.css";
import MainHeader from "@/reusable_sections/Header";
import CaptureEveryOpportunity from "./sections/CaptureEveryOpportunity";
import LeadAcceleration from "./sections/LeadAcceleration";
import AutomatedScheduling from "./sections/AutomatedScheduling";
import Footer from "@/reusable_sections/Footer";
export default function SolutionsPage() {
  return <div>
      <MainHeader />
      <CaptureEveryOpportunity />
      <LeadAcceleration />
      <AutomatedScheduling />
      <Footer />
    </div>;
}